export function useVatPlans() {
    onMounted(async () => {
        await load()
    })

    const load = async () => {
        await supplierStore.loadVatPlans()
    }

    const vatPlans = computed(() => supplierStore.vatPlans)

    return {vatPlans}
}
